import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'arrayString',
    standalone: false
})
export class ArrayStringPipe implements PipeTransform {
  transform(value: string[]): string {
    return value.join(',');
  }
}
